import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DragDataClass;
function DragData() {
  if (DragDataClass === VOID) {
    class $ {
      static ccy(label, typeToData, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        var $this = createThis(this);
        $this.zcx_1 = label;
        $this.acy_1 = typeToData;
        $this.bcy_1 = dragShadow;
        return $this;
      }
      static dcy(label, mimeType, data, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        return this.ccy(label, mapOf(to(mimeType, data)), dragShadow);
      }
      gi(mimeType) {
        return this.acy_1.p3(mimeType);
      }
      ecy(label, typeToData, dragShadow) {
        return DragData().ccy(label, typeToData, dragShadow);
      }
      fcy(label, typeToData, dragShadow, $super) {
        label = label === VOID ? this.zcx_1 : label;
        typeToData = typeToData === VOID ? this.acy_1 : typeToData;
        dragShadow = dragShadow === VOID ? this.bcy_1 : dragShadow;
        return $super === VOID ? this.ecy(label, typeToData, dragShadow) : $super.ecy.call(this, label, typeToData, dragShadow);
      }
      toString() {
        return 'DragData(label=' + this.zcx_1 + ', typeToData=' + toString(this.acy_1) + ', dragShadow=' + toString_0(this.bcy_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.zcx_1);
        result = imul(result, 31) + hashCode(this.acy_1) | 0;
        result = imul(result, 31) + (this.bcy_1 == null ? 0 : this.bcy_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragData()))
          return false;
        if (!(this.zcx_1 === other.zcx_1))
          return false;
        if (!equals(this.acy_1, other.acy_1))
          return false;
        if (!equals(this.bcy_1, other.bcy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragData');
    DragDataClass = $;
  }
  return DragDataClass;
}
var DragShadowClass;
function DragShadow() {
  if (DragShadowClass === VOID) {
    class $ {
      constructor(view, xAlign, yAlign, xOffset, yOffset) {
        xAlign = xAlign === VOID ? Align_Center_getInstance() : xAlign;
        yAlign = yAlign === VOID ? Align_Center_getInstance() : yAlign;
        xOffset = xOffset === VOID ? null : xOffset;
        yOffset = yOffset === VOID ? null : yOffset;
        this.gcy_1 = view;
        this.hcy_1 = xAlign;
        this.icy_1 = yAlign;
        this.jcy_1 = xOffset;
        this.kcy_1 = yOffset;
      }
      toString() {
        var tmp = this.gcy_1.toString();
        var tmp_0 = this.hcy_1.toString();
        var tmp_1 = this.icy_1.toString();
        var tmp_2 = this.jcy_1;
        var tmp_3 = toString_0(tmp_2 == null ? null : new (Dimension())(tmp_2));
        var tmp_4 = this.kcy_1;
        return 'DragShadow(view=' + tmp + ', xAlign=' + tmp_0 + ', yAlign=' + tmp_1 + ', xOffset=' + tmp_3 + ', yOffset=' + toString_0(tmp_4 == null ? null : new (Dimension())(tmp_4)) + ')';
      }
      hashCode() {
        var result = hashCode(this.gcy_1);
        result = imul(result, 31) + this.hcy_1.hashCode() | 0;
        result = imul(result, 31) + this.icy_1.hashCode() | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.jcy_1;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Dimension__hashCode_impl_p583vw(this.jcy_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.kcy_1;
        if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = Dimension__hashCode_impl_p583vw(this.kcy_1);
        }
        result = tmp_2 + tmp_3 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragShadow()))
          return false;
        if (!equals(this.gcy_1, other.gcy_1))
          return false;
        if (!this.hcy_1.equals(other.hcy_1))
          return false;
        if (!this.icy_1.equals(other.icy_1))
          return false;
        var tmp = this.jcy_1;
        var tmp_0 = tmp == null ? null : new (Dimension())(tmp);
        var tmp_1 = other.jcy_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Dimension())(tmp_1)))
          return false;
        var tmp_2 = this.kcy_1;
        var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
        var tmp_4 = other.kcy_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Dimension())(tmp_4)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragShadow');
    DragShadowClass = $;
  }
  return DragShadowClass;
}
var DragEventClass;
function DragEvent() {
  if (DragEventClass === VOID) {
    class $ {
      constructor(data, xInView, yInView) {
        this.lcy_1 = data;
        this.mcy_1 = xInView;
        this.ncy_1 = yInView;
      }
      toString() {
        return 'DragEvent(data=' + this.lcy_1.toString() + ', xInView=' + this.mcy_1 + ', yInView=' + this.ncy_1 + ')';
      }
      hashCode() {
        var result = this.lcy_1.hashCode();
        result = imul(result, 31) + getNumberHashCode(this.mcy_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.ncy_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragEvent()))
          return false;
        if (!this.lcy_1.equals(other.lcy_1))
          return false;
        if (!equals(this.mcy_1, other.mcy_1))
          return false;
        if (!equals(this.ncy_1, other.ncy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragEvent');
    DragEventClass = $;
  }
  return DragEventClass;
}
//region block: exports
export {
  DragData as DragData2helsigoeiabk,
  DragEvent as DragEventn7vmft816tmz,
  DragShadow as DragShadow11keb9piinnfw,
};
//endregion

//# sourceMappingURL=DragData.mjs.map
